import React from 'react';
import VideosList from '../VideosList';

function SearchResults() {
  return (
    <div className="bg-gray-100 flex flex-col items-center justify-center min-h-screen">
      <VideosList />
    </div>
  );
}

export default SearchResults;
